import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=46be4f54&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be4f54",
  null
  
)

export default component.exports